import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, NavLink, Navigate, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import './home/home.css';
import NewsPage from './news/NewsPage';
import JobsLayout from './jobs/JobsLayout';
import MusicLayout from './music/MusicLayout';
import HomePage from './home/HomePage';
import MusicPlayer from './music/MusicPlayer';
import MobileHeader from './components/MobileHeader';
import { PlayerProvider } from './music/PlayerContext';
import { AuthProvider, useAuth } from './auth/AuthContext';
import AccountPage from './auth/AccountPage';

function AppInner() {
  const navigate = useNavigate();
  const location = useLocation();

  const [jobIndustryFilter, setJobIndustryFilter] = useState([]);
  const [jobRoleFilter, setJobRoleFilter] = useState([]);

  const handleNavigateToJobs = (filters = {}) => {
    setJobIndustryFilter(filters.industries || []);
    setJobRoleFilter(filters.roles || []);
    navigate('/jobs/roles');
  };

  const handleNavigateToPaper = (section) => {
    navigate(section ? `/paper/${section}` : '/paper');
  };

  const { user } = useAuth();

  return (
    <div className="App">
      {/* ── Mobile header: ferl + mini-player + hamburger (only on screens < 768px) ── */}
      <MobileHeader onJobsClick={() => { setJobIndustryFilter([]); setJobRoleFilter([]); }} />

      {/* ── Top bar: 4-col grid — logo | controls | island | volume+account ── */}
      <div className="app-top-bar">
        <div className="app-logo">ferl</div>
        <MusicPlayer accountLink={
          <NavLink to="/account" className={`app-tabs-account${location.pathname.startsWith('/account') ? ' active' : ''}`}>
            <svg className="app-account-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="8" r="4"/>
              <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
            </svg>
            <span className="app-tabs-account-label">{user ? user.username : 'Sign in'}</span>
          </NavLink>
        } />
      </div>

      {/* ── Body: sidebar + content ── */}
      <div className="app-body">
        <nav className="app-sidebar">
          <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink>
          <NavLink
            to="/jobs"
            className={location.pathname.startsWith('/jobs') ? 'active' : ''}
            onClick={() => { setJobIndustryFilter([]); setJobRoleFilter([]); }}
          >Jobs</NavLink>
          <NavLink to="/paper/stories" className={location.pathname.startsWith('/paper') ? 'active' : ''}>The Paper</NavLink>
          <NavLink
            to="/music/playlist"
            className={location.pathname.startsWith('/music') ? 'active' : ''}
          >Playlist</NavLink>
        </nav>

        <main className="app-content">

          <Routes>
            <Route path="/" element={
              <HomePage
                onNavigateToJobs={handleNavigateToJobs}
                onNavigateToPaper={handleNavigateToPaper}
              />
            } />

            <Route path="/jobs/*" element={
              <JobsLayout
                selectedIndustries={jobIndustryFilter}
                setSelectedIndustries={setJobIndustryFilter}
                selectedRoles={jobRoleFilter}
                setSelectedRoles={setJobRoleFilter}
              />
            } />

            <Route path="/music/*" element={<MusicLayout />} />

            <Route path="/paper"                    element={<Navigate to="/paper/stories" replace />} />
            <Route path="/paper/:section"          element={<NewsPage />} />
            <Route path="/paper/:section/:article" element={<NewsPage />} />

            <Route path="/account" element={
              <AccountPage onNavigateToJobs={handleNavigateToJobs} />
            } />

            <Route path="*" element={
              <HomePage
                onNavigateToJobs={handleNavigateToJobs}
                onNavigateToPaper={handleNavigateToPaper}
              />
            } />
          </Routes>
        </main>
      </div>

      {/* ── Mobile bottom tabs ── */}
      <nav className="app-mobile-tabs">
        <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink>
        <NavLink to="/jobs" className={location.pathname.startsWith('/jobs') ? 'active' : ''} onClick={() => { setJobIndustryFilter([]); setJobRoleFilter([]); }}>Jobs</NavLink>
        <NavLink to="/paper/stories" className={location.pathname.startsWith('/paper') ? 'active' : ''}>Paper</NavLink>
        <NavLink to="/music/playlist" className={location.pathname.startsWith('/music') ? 'active' : ''}>Playlist</NavLink>
        <NavLink to="/account" className={location.pathname.startsWith('/account') ? 'active' : ''}>Account</NavLink>
      </nav>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PlayerProvider>
          <AppInner />
        </PlayerProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
